import * as React from "react";

const MOBILE_BREAKPOINT = 1024;
const mobileMql = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

function getMatches(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(mobileMql).matches;
}

/**
 * One source of truth: matchMedia, same for initial state and "change" events.
 * Using innerWidth for init could diverge from the listener on edge px / zoom.
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(getMatches);

  React.useEffect(() => {
    const mql = window.matchMedia(mobileMql);
    const onChange = () => {
      setIsMobile(mql.matches);
    };
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
